import React, { useState, useEffect } from 'react'
import Header from './Header'
import { Card, Grid, Typography } from '@mui/material'
import { getTransactionStatus } from '../../redux/actions/ComponentCallsActions'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CryptoJS from 'crypto-js'
import { EncKeys } from '../../../config'

const UpiWaitingPage = () => {
    const [showTimer, setShowTimer] = useState(true)
    const history = useHistory()
    const dispatch = useDispatch()
    const paymentData = useSelector((state) => state.customerData)
    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    // Set the timeout duration in seconds
    const timeoutDuration = 300 // 5 minutes (adjust as needed)
    const [timeLeft, setTimeLeft] = useState(timeoutDuration)

    useEffect(() => {
        const timerInterval = setInterval(() => {
            // Decrement the time left every second
            setTimeLeft((prevTime) => prevTime - 1)
        }, 1000)

        // Clear the interval when the component is unmounted
        return () => clearInterval(timerInterval)
    }, [])

    useEffect(() => {
        // Check if the time has expired
        if (timeLeft <= 0) {
            // Time has expired, switch to expiredDiv
            setShowTimer(false)
        }
    }, [timeLeft])

    // Calculate minutes and seconds separately
    const minutes = Math.floor(timeLeft / 60)
    const seconds = timeLeft % 60

    // Format minutes and seconds with leading zeros
    const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`

    const getStatus = () => {
        const postRequest = {
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
        }

        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            getTransactionStatus(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        let actualResponse = JSON.parse(decrypted)
                        history.push({
                            pathname: '/TransactionStatus',
                            state: actualResponse,
                        })
                    }
                },
                (err) => {
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }

    useEffect(() => {
        if (showTimer === true) {
            const intervalId = setInterval(() => {
                getStatus()
            }, 10000)
            return () => clearInterval(intervalId)
        } else {
            setTimeout(() => {
                window.location.href =
                    paymentData.customerData.PaymentRequest.RedirectUrl
            }, 3000)
        }
    }, [showTimer])

    return (
        <>
            <Header />
            <div
                className="m-sm-30 transactionBody"
                style={{ paddingBottom: '100px' }}
            >
                <Grid pt={6} container spacing={0}>
                    <Grid item xs={0} md={2}></Grid>
                    <Grid item xs={12} md={8}>
                        <Card
                            className="px-6 pt-2 pb-4"
                            style={{
                                backgroundColor: 'white',
                                margin: 10,
                                height: '20rem',
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: '#2177F9',
                                    padding: '10px',
                                    color: 'white',
                                }}
                            >
                                <Typography>PAYMENT STATUS</Typography>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                style={{ padding: '20px' }}
                            >
                                {showTimer === true ? (
                                    <Grid item xs={12}>
                                        <div
                                            id="timerDiv"
                                            style={{
                                                paddingTop: '5vh',
                                                paddingBottom: '10px',
                                                textAlign: 'center',
                                                height: '100%',
                                            }}
                                        >
                                            <span style={{ fontSize: '20px' }}>
                                                Please open and complete payment
                                                in UPI app
                                            </span>
                                            <br />
                                            <br />
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    marginBottom: '20px',
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: '25px',
                                                        color: 'darkblue',
                                                    }}
                                                    id="timerId"
                                                >
                                                    Time Left: {formattedTime}
                                                </p>
                                            </div>
                                            <span style={{ fontSize: '20px' }}>
                                                Do not press the back button
                                                until payment is complete
                                            </span>
                                        </div>
                                    </Grid>
                                ) : (
                                    <Grid item xs={12}>
                                        <div
                                            id="expiredDiv"
                                            style={{
                                                paddingTop: '5vh',
                                                height: '100%',
                                            }}
                                        >
                                            <div
                                                style={{ textAlign: 'center' }}
                                            >
                                                <p
                                                    style={{
                                                        fontSize: '25px',
                                                        color: 'darkblue',
                                                    }}
                                                >
                                                    Your payment was declined.
                                                    Time limit has expired
                                                </p>
                                            </div>
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    marginTop: '20px',
                                                }}
                                            >
                                                <span
                                                    style={{ fontSize: '20px' }}
                                                >
                                                    Please try again
                                                </span>
                                            </div>
                                        </div>
                                    </Grid>
                                )}
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default UpiWaitingPage
